export const environment = {
  platformOrigins: [
    'http://localhost:4200',
    'https://int.dx.arrk.com'
  ] as const,
  cognitoClientIds: [
    '76fgstks71ssgsoga6a0a87m1l', // dev
    '1e8omcbja21dsgqmouqodma5tv', // int
    'xxxxxxxxxxxxxxxxxxxxxxxxxx' // prod — update when known
  ] as const,
  bypassGuard: false,
  cmsApiBaseUrl: 'https://cms-api-int.internal.dev.dx.arrk.com',
  cmsDevToken: null as string | null
};
